module.exports = __webpack_public_path__ + "img/success.3431e305.png";